const BLITZ_INJECT_SELECTOR = ".blitz-inject:not(.blitz-inject--injected)";
const BLITZ_CSRF_URL_FRAGMENT = "blitz/csrf/json";

function getInjectElements(root = document) {
  const elements = new Set();

  if (root instanceof Element && root.matches(BLITZ_INJECT_SELECTOR)) {
    elements.add(root);
  }

  if (typeof root.querySelectorAll === "function") {
    for (const element of root.querySelectorAll(BLITZ_INJECT_SELECTOR)) {
      elements.add(element);
    }
  }

  return [...elements];
}

function getInjectUrl({ uri, params }) {
  if (!uri) {
    return null;
  }

  if (!params) {
    return uri;
  }

  return uri + (uri.includes("?") ? "&" : "?") + params;
}

async function replaceUrl(url, injectElements) {
  try {
    const response = await fetch(url);

    if (response.status >= 300) {
      return null;
    }

    const responseText = await response.text();
    const responseJson = url.includes(BLITZ_CSRF_URL_FRAGMENT)
      ? JSON.parse(responseText)
      : null;

    injectElements.forEach((injectElement) => {
      if (injectElement.property) {
        injectElement.element.innerHTML =
          responseJson?.[injectElement.property] ?? "";
      } else {
        injectElement.element.innerHTML = responseText;
      }

      injectElement.element.classList.add("blitz-inject--injected");

      document.dispatchEvent(
        new CustomEvent("afterBlitzInject", {
          detail: injectElement,
        }),
      );
    });
  } catch (error) {
    console.error("Blitz inject reprocessing failed:", error);
    return null;
  }

  return null;
}

export default async function reprocessBlitzInjects(root = document) {
  if (
    !document.dispatchEvent(
      new CustomEvent("beforeBlitzInjectAll", {
        cancelable: true,
      }),
    )
  ) {
    return;
  }

  const injectElements = {};
  const promises = [];

  getInjectElements(root).forEach((element) => {
    const injectElement = {
      element,
      id: element.getAttribute("data-blitz-id"),
      uri: element.getAttribute("data-blitz-uri"),
      params: element.getAttribute("data-blitz-params"),
      property: element.getAttribute("data-blitz-property"),
    };

    if (
      !document.dispatchEvent(
        new CustomEvent("beforeBlitzInject", {
          cancelable: true,
          detail: injectElement,
        }),
      )
    ) {
      return;
    }

    const url = getInjectUrl(injectElement);
    if (!url) {
      return;
    }

    injectElements[url] ??= [];
    injectElements[url].push(injectElement);
  });

  for (const url in injectElements) {
    promises.push(replaceUrl(url, injectElements[url]));
  }

  await Promise.all(promises);

  document.dispatchEvent(new CustomEvent("afterBlitzInjectAll"));
}
